import React from "react";
const Url = process.env.REACT_APP_SERVER_URL;

const CarGallery = ({ carDetails, setShowGallery }) => {
  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.8)", zIndex: "1000" }}
    >
      <div className="modal-dialog modal-xl" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Car Image Gallery</h5>
            <button
              type="button"
              className="btn style2"
              onClick={() => setShowGallery(false)}
            >
              ✖
            </button>
          </div>
          <div className="modal-body position-relative">
            <div
              id="galleryCarousel"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner">
                {carDetails.imageGallery.map((img, index) => (
                  <div
                    className={`carousel-item ${index === 0 ? "active" : ""}`}
                    key={index}
                  >
                    <img
                      src={`${Url}/${img}`}
                      className="d-block w-100"
                      alt={`Slide ${index + 1}`}
                      style={{ maxHeight: "600px", objectFit: "contain" }}
                    />
                  </div>
                ))}
              </div>
              <button
                className="carousel-control-prev custom-control-btn"
                type="button"
                data-bs-target="#galleryCarousel"
                data-bs-slide="prev"
              >
                <span className="carousel-control-prev-icon"></span>
              </button>
              {/* Next Button */}
              <button
                className="carousel-control-next custom-control-btn"
                type="button"
                data-bs-target="#galleryCarousel"
                data-bs-slide="next"
              >
                <span className="carousel-control-next-icon"></span>
              </button>
            </div>
            {/* Close Button */}
            <button
              className="btn-close custom-close-btn"
              onClick={() => setShowGallery(false)}
              aria-label="Close"
            ></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarGallery;
